import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const selectStyles = {
	menuPortal: (base) => ({ ...base, zIndex: 9999 }),
	control: (base) => ({
		...base,
		minHeight: "36px",
		borderColor: "#d1d5db",
		"&:hover": { borderColor: "#7fb02f" },
	}),
};

export function SelectInput({
	isCreatable,
	selectRef,
	selectedValue,
	onChange,
	onCreateOption,
	dynamicOptions,
	isMulti,
	isClearable,
	isSearchable,
	isSaving,
	disabled,
	placeholder,
	noOptionsMessage,
	loadingMessage,
	formatCreateLabel,
	getOptionValue,
	getOptionLabel,
	onKeyDown,
	onMenuOpen,
	onMenuClose,
	components,
	className,
	filterOption,
}) {
	const commonProps = {
		ref: selectRef,
		value: selectedValue,
		onChange,
		options: dynamicOptions,
		isMulti,
		isClearable,
		isSearchable,
		isDisabled: isSaving || disabled,
		placeholder,
		noOptionsMessage,
		loadingMessage,
		getOptionValue,
		getOptionLabel,
		onKeyDown,
		menuPortalTarget: document.body,
		onMenuOpen,
		onMenuClose,
		components,
		styles: selectStyles,
		className,
		...(filterOption ? { filterOption } : {}),
	};

	if (isCreatable) {
		return <CreatableSelect {...commonProps} onCreateOption={onCreateOption} formatCreateLabel={formatCreateLabel} />;
	}

	return <Select {...commonProps} />;
}
